var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 28,
    viewBox: "0 0 48 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.481934,
    width: 47.2907,
    height: 28,
    fill: "url(#pattern0_173_332)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_173_332",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_173_332",
    transform: "matrix(0.0065787 0 0 0.0111111 0.203959 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_173_332",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAAAXNSR0IArs4c6QAABGpJREFUeF7t3M+LHEUUB/BX3Tuu+GOPBtbuYZedXFYFL3oxf0Q0ETQmBi/RS8SbICgKAcWL5CreDDnpQYkiiHgQJSokoLAXs7sz1cWCv7K6atRhZ57WMmtgnJ550/2mjN3fvc6rV1OfedtTXV01hvAXRMAE6QWdEKADFQGgAR1IIFA3qGhABxII1A0qGtCBBAJ1g4oGdCCBQN2gogEdSCBQN6hoQAcSCNQNKhrQgQQCdYOKBnQggUDdoKIBXVwgSZKDxph+lmXrxbPotqxURS8vLx/Y3d19m4ge8EzM/FkURSestRu6bNNnqxR0mqYe+aEhhm2P3el03pueR69F1aB/JaJbR/D0jTFnrLUvEVFfj0+eqWrQPG7oxpiPG43GI+vr69/JiXQiawU9IMuY+WHn3Oc6hLIsdYT2Mn8aY5611p6VMZWPqiv0nhwzv9nv95/a2tq6Vp5yfIZaQw+wL8dxfKTT6WzOErv20APcH5n5uHPug1lhA/q6LDPzq86552YxBQT0UAkbY94nouPW2m3N6gb0aE1LREezLPtSCxvQ+ZJ/MPNp59wbGtiAnqDop4BE9KRz7vcy4ICW6V3yU8B2u92Whf87aiL00tLSzX5Sz8zHiOguIrqlaGf/83bfG2MetdZ+VGQcY6EXFxfTOI798uI9RZJXsE3PGPO8tfYVf2M5zfhyoX0l93q9L4A8kvOdRqNxcmNj42cpdi50s9l8hplfkyaqYdw3zHzEOfe1ZOy50Gma+mq+T5KkxjG/MfMp59z5SQbjoH8hotsmJcDre6uAry8sLJxeW1vr5nmMg57qYl93cP8geH5+/sG8pzeA1q2QT7MsOzQqJaB1of1l5KBz7spwWkArQxNRa9TGHUDrQuPSoes5MtvFubm5w5ubm99Oe43G9E746ZSd3vl9D/cL+6pr2DVm9kuo5yYBjLsFf5qZg+17mPRGb8DXrwxuwb+SvLdc6FarNd/tdi8y872SRDWLeTeO45Ptdvsn6bjHLpMmSXJnFEUXgP0PZ+/vJ+QvZFn2stoy6X7q1dXVm3Z2dk5FUeQX/u9m5tuln2LF4n4wxhyz1n5YZFwTn7AUSfpftUnTdFbrM5eiKDpaZjcToCdUBR7OjgBSrmhsN8grQkVobKAZ95+uAe23hPX7/RPOuaua3zW4Rl/XxCZHaWWVqOirzPwYtu0KpYtAM/NlP3Wb9VnEWl86cLRCWMHDYVNUNA4LFTTeayaExvG3MsgSaBzoLCs8aJ+mad4RZb8GcibLshdncT5F8vYr9WXYbDbf8ovxQwPfNsY8bq29IAGZVUyloFdWVu7odrv+Fw72N7F8QkRP3Ai/21Ep6P1qTJKkFcdxr8yypnZlVxJaG0kjH6A1FAU5AC1A0ggBtIaiIAegBUgaIYDWUBTkALQASSME0BqKghyAFiBphABaQ1GQA9ACJI0QQGsoCnIAWoCkEQJoDUVBDkALkDRCAK2hKMgBaAGSRgigNRQFOQAtQNIIAbSGoiDHX+iLoWos8PzSAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.a57902d6cffbcce3e195ef686302ae6f.svg";
export { ForwardRef as ReactComponent };